import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbtackBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "thumbtack" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.29937 5.85534C3.16747 5.93273 3.05508 6.03933 2.97084 6.16696C2.8866 6.29458 2.83275 6.43983 2.81343 6.59153C2.79411 6.74323 2.80985 6.89733 2.85942 7.042C2.90899 7.18667 2.99108 7.31803 3.09937 7.42601L8.5747 12.9013C8.68267 13.0096 8.81404 13.0917 8.95871 13.1413C9.10338 13.1909 9.25748 13.2066 9.40918 13.1873C9.56088 13.168 9.70613 13.1141 9.83375 13.0299C9.96138 12.9456 10.068 12.8332 10.1454 12.7013C10.7939 11.5856 10.9873 10.2627 10.6854 9.00801L15.038 6.23801C15.1644 6.15764 15.2711 6.04993 15.3502 5.92283C15.4294 5.79572 15.479 5.65245 15.4954 5.50361C15.5117 5.35477 15.4945 5.20415 15.4449 5.06287C15.3953 4.92159 15.3146 4.79326 15.2087 4.68734L11.3134 0.792006C11.2075 0.686126 11.0792 0.605373 10.938 0.555705C10.7967 0.506037 10.6461 0.488723 10.4973 0.50504C10.3484 0.521358 10.2051 0.57089 10.078 0.649981C9.95087 0.729072 9.84312 0.835704 9.7627 0.962006L6.9927 5.31534C5.73797 5.01338 4.41513 5.20679 3.29937 5.85534Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83533 10.164L0.5 15.4993",
			stroke: "currentColor",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgThumbtackBold;
